import {
  Alert,
  Box,
  CircularProgress,
  Grid,
  Snackbar,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ButtonCustomized from "../../../../common/components/ButtonCustomized";
import PaperCustomized from "../../../../common/components/PaperCustomized";
import ScrollToTop from "../../../../common/components/ScrollToTop";
import TextFieldCustomized from "../../../../common/components/TextFieldCustomized";
import { GO_BACK } from "../../../../common/constants/routerConstants";
import {
  SUCCES_ACCEPTATION_ANNULATION_BANQUE,
  SUCCES_ACCEPTATION_CHANGEMENT_BANQUE,
  SUCCES_ACCEPTATION_DOMICILIATION,
  SUCCES_ACCEPTATION_MODIFICATION_BANQUE,
  SUCCES_ACCEPTATION_PRE_DOMICILIATION,
  SUCCES_REFUS_ANNULATION_BANQUE,
  SUCCES_REFUS_CHANGEMENT_BANQUE,
  SUCCES_REFUS_DOMICILIATION,
  SUCCES_REFUS_MODIFICATION_BANQUE,
  SUCCES_REFUS_PRE_DOMICILIATION,
} from "../../../../common/utils/constante";
import {
  acceptDomiciliationBanque,
  acceptDomiciliationBanqueReinitialization,
  getReponseDomiciliationBanqueData,
  refuseDomiciliationBanque,
  refuseDomiciliationBanqueReinitialization,
  searchTitres,
} from "../../state/TiActions";
import TitreDetailConsult, {
  BoldTypography,
} from "../Details/TitreDetaillConsult";
function ReponseDomiciliationBanque(props) {
  const { id } = useParams();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const contentBottomRef = useRef(null);
  const [isDecision, setIsDecision] = useState(
    location.state?.isDecision || false,
  );
  const tiReducer = useSelector((state) => state.tiReducer);
  const tiDetail = tiReducer?.titreDetail;
  const tiDomiciliationBanque = tiDetail?.tiDomiciliationBanque;
  const loading = useSelector((state) => state?.tiReducer?.isLoading);
  const [alertMessage, setAlertMessage] = useState(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [severity, setSeverity] = useState(null);
  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  const { content: data } = useSelector(
    (state) => state?.tiReducer?.reponseDomiciliationBanqueData,
  );
  useEffect(() => {
    dispatch(getReponseDomiciliationBanqueData(id));
  }, []);
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);

  useEffect(() => {
    if (loading === false) {
      if (isDecision === true && contentBottomRef.current) {
        setTimeout(() => {
          contentBottomRef.current.scrollIntoView({ behavior: "smooth" });
        }, 0);
      } else if (isDecision === false) {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }
    }
  }, [isDecision, loading]);
  const [numDomiciliation, setNumDomiciliation] = useState(null);
  const [numDomiciliationError, setNumDomiciliationError] = useState(null);
  const [observationError, setObservationError] = useState(null);

  const [observation, setObservation] = useState("");

  // Get current search object from Redux state
  const currentSearchObject = useSelector(
    (state) => state.tiReducer?.searchTitreObject,
  );

  // Callback function to navigate back and trigger search
  const handleSuccessCallback = () => {
    navigate(GO_BACK);

    if (currentSearchObject) {
      dispatch(searchTitres(currentSearchObject, false));
    }
  };

  const handleNumDomiciliation = (e) => {
    setNumDomiciliation(e);
  };
  const handleObservation = (e) => {
    setObservation(e);
  };
  useEffect(() => {
    if (Boolean(data?.reponseBanque?.numeroDomiciliation)) {
      setNumDomiciliation(data?.reponseBanque?.numeroDomiciliation);
    }
  }, [data?.reponseBanque?.numeroDomiciliation]);
  useEffect(() => {
    if (
      numDomiciliationError &&
      (numDomiciliation === null || numDomiciliation === "")
    ) {
      setNumDomiciliationError(null);
    }
    if (
      numDomiciliationError &&
      (numDomiciliation !== null || numDomiciliation !== "")
    ) {
      setNumDomiciliationError(null);
    }
  }, [numDomiciliation]);
  useEffect(() => {
    if (observationError && (observation === null || observation === "")) {
      setObservationError(null);
    }
    if (observationError && observation !== "") {
      setObservationError(null);
    }
  }, [observation]);
  const acceptationIsSuccessed = useSelector(
    (state) => state?.tiReducer?.isSuccessedDomiciliation,
  );
  const acceptationIsLoading = useSelector(
    (state) => state?.tiReducer?.isLoadingDomiciliation,
  );
  const refusIsLoading = useSelector(
    (state) => state.tiReducer.isLoadingRefusDomiciliation,
  );
  const refusIsSuccessed = useSelector(
    (state) => state.tiReducer.isSuccessedRefusDomiciliation,
  );

  useEffect(() => {
    if (refusIsSuccessed) {
      if (
        data.donneesTitreImportation.typeEtatTitreImportation.code ===
        "DOM_SOUMI_BAN"
      ) {
        setAlertMessage(SUCCES_REFUS_MODIFICATION_BANQUE);
      } else if (data.msgTituloImpLast.typeMessage.code === "DAT") {
        setAlertMessage(SUCCES_REFUS_ANNULATION_BANQUE);
      } else if (
        data.msgTituloImpLast.typeMessage.code === "DCG" ||
        data.msgTituloImpLast.typeMessage.code === "DCGN"
      ) {
        setAlertMessage(SUCCES_REFUS_CHANGEMENT_BANQUE);
      } else {
        setAlertMessage(
          Boolean(data.reponseBanque.domiciliacion)
            ? SUCCES_REFUS_DOMICILIATION
            : SUCCES_REFUS_PRE_DOMICILIATION,
        );
      }
      setAlertOpen(true);
      setSeverity("success");
      dispatch(refuseDomiciliationBanqueReinitialization());
    }
  }, [refusIsSuccessed]);
  const refuseDomiciliationHandler = () => {
    if (
      observation == null ||
      observation === "" ||
      observation.replace(/\s/g, "") === ""
    ) {
      setObservationError("Ce champs est obligation.");
    } else {
      dispatch(
        refuseDomiciliationBanque(
          {
            idDomiciliationBancaire: data.domiciliationBanque.id,
            idTitreImportation: id,
            numDomiciliation: numDomiciliation,
            observation: observation,
            dateAcceptation: data.reponseBanque.dateAcceptation,
            dateExpiration: data.reponseBanque.dateExpiration,
            dateDebutValidite: tiDomiciliationBanque?.dateDebutValiditee,
            dateFinValidite: tiDomiciliationBanque?.dateFinValiditee,
            predom: !Boolean(data.reponseBanque.domiciliacion),
          },
          handleSuccessCallback,
        ),
      );
    }
  };
  useEffect(() => {
    if (acceptationIsSuccessed === true) {
      if (
        data.donneesTitreImportation.typeEtatTitreImportation.code ===
        "DOM_SOUMI_BAN"
      ) {
        setAlertMessage(SUCCES_ACCEPTATION_MODIFICATION_BANQUE);
      } else if (data.msgTituloImpLast.typeMessage.code === "DAT") {
        setAlertMessage(SUCCES_ACCEPTATION_ANNULATION_BANQUE);
      } else if (
        data.msgTituloImpLast.typeMessage.code === "DCG" ||
        data.msgTituloImpLast.typeMessage.code === "DCGN"
      ) {
        setAlertMessage(SUCCES_ACCEPTATION_CHANGEMENT_BANQUE);
      } else {
        setAlertMessage(
          Boolean(data.reponseBanque.domiciliacion)
            ? SUCCES_ACCEPTATION_DOMICILIATION
            : SUCCES_ACCEPTATION_PRE_DOMICILIATION,
        );
      }
      setAlertOpen(true);
      setSeverity("success");
      dispatch(acceptDomiciliationBanqueReinitialization());
    }
  }, [acceptationIsSuccessed]);
  const accepterDomiciliation = () => {
    if (
      Boolean(data.reponseBanque?.domiciliacion) &&
      (numDomiciliation === null || numDomiciliation === "")
    ) {
      setNumDomiciliationError("Ce champs est obligation.");
    } else {
      dispatch(
        acceptDomiciliationBanque(
          {
            idDomiciliationBancaire: data.domiciliationBanque.id,
            idTitreImportation: id,
            numDomiciliation: numDomiciliation ?? 0,
            observation: observation,
            dateAcceptation: data.reponseBanque.dateAcceptation,
            dateExpiration: data.reponseBanque.dateExpiration,
            dateDebutValidite:
              tiDomiciliationBanque?.dateDebutValiditee ??
              data?.domiciliationBanque?.dateDebutValiditee,
            dateFinValidite:
              tiDomiciliationBanque?.dateFinValiditee ??
              data?.domiciliationBanque?.dateFinValiditee,
            predom: !Boolean(data.reponseBanque?.domiciliacion),
          },
          handleSuccessCallback,
        ),
      );
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        gap: "20px",
      }}
    >
      <Helmet>
        <title>{"Résponses de la banque"}</title>
      </Helmet>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          gap: "20px",
        }}
      >
        <TitreDetailConsult />
        {loading ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexGrow: 1,
              mt: "20%",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            <PaperCustomized title="Demande du titre" forActions={false}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={3}>
                  <BoldTypography
                    label="Fonction de la demande"
                    value={
                      data?.msgTituloImpLast?.typeMessage?.description ?? "-"
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <BoldTypography
                    label="Nom utilisateur"
                    value={data?.msgTituloImpLast?.nombreUsuario ?? "-"}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <BoldTypography
                    label="Etat"
                    value={data?.msgTituloImpLast?.etat?.description ?? "-"}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <BoldTypography
                    label="Date"
                    value={
                      Boolean(data?.msgTituloImpLast?.fechaMsg)
                        ? moment(data?.msgTituloImpLast?.fechaMsg).format(
                            "DD/MM/YYYY LT",
                          )
                        : "-"
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <BoldTypography
                    label="Nom message"
                    value={data?.msgTituloImpLast?.nombreMensaje ?? "-"}
                  />
                </Grid>
              </Grid>
            </PaperCustomized>
            {!acceptationIsLoading ? (
              <PaperCustomized title="Réponse à titre" forActions={false}>
                <Grid container spacing={1}>
                  {(data?.msgTituloImpLast?.typeMessage?.id == 16 ||
                    data?.msgTituloImpLast?.typeMessage?.id == 9) && (
                    <Typography
                      sx={{
                        marginBottom: 2,
                        color: "#d32f2f",
                        fontWeight: "bold",
                        marginLeft: 2,
                      }}
                    >
                      <div>
                        <div
                          style={{
                            textDecoration: "underline",
                            display: "inline",
                            marginRight: 4,
                          }}
                        >
                          Important :
                        </div>
                        Prière de vérifier que la situation des règlements
                        financiers de ce titre est à jour avant d'accepter
                        l'opération de changement de guichet.
                      </div>
                    </Typography>
                  )}
                  <Grid item xs={12} sm={6} md={3}>
                    <TextFieldCustomized
                      label="Date d'acceptation / refus"
                      value={
                        Boolean(data?.reponseBanque?.dateAcceptation)
                          ? moment(data?.dateAcceptation).format(
                              "DD/MM/YYYY LT",
                            )
                          : "-"
                      }
                      disabled
                      fullWidth
                    />
                  </Grid>
                  {Boolean(data.reponseBanque?.domiciliacion) && (
                    <>
                      <Grid item xs={12} sm={6} md={3}>
                        <TextFieldCustomized
                          label="N° de domiciliation"
                          name="numeroDomiciliation"
                          value={
                            numDomiciliation
                              ? numDomiciliation
                              : data?.reponseBanque?.numeroDomiciliation || ""
                          }
                          onChange={handleNumDomiciliation}
                          inputProps={{ maxLength: 13 }}
                          error={numDomiciliationError}
                          fullWidth
                          obligatoire
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <TextFieldCustomized
                          label="Date début de validité"
                          name="dateDebutValidite"
                          value={
                            Boolean(
                              data?.domiciliationBanque?.dateDebutValiditee,
                            )
                              ? moment(
                                  data?.domiciliationBanque?.dateDebutValiditee,
                                ).format("DD/MM/YYYY LT")
                              : "-"
                          }
                          disabled
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <TextFieldCustomized
                          label="Date fin de validité	"
                          name="dateFinValidite"
                          value={
                            Boolean(data?.domiciliationBanque?.dateFinValiditee)
                              ? moment(
                                  data?.domiciliationBanque?.dateFinValiditee,
                                ).format("DD/MM/YYYY LT")
                              : "-"
                          }
                          disabled
                          fullWidth
                        />
                      </Grid>
                    </>
                  )}
                  <Grid item xs={12}>
                    <TextFieldCustomized
                      label="Observations"
                      value={observation}
                      onChange={handleObservation}
                      bigField
                      error={observationError}
                      rows={3}
                    />
                  </Grid>
                  <Grid item xs={12}></Grid>
                </Grid>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    marginTop: 1,
                    gap: 1,
                  }}
                >
                  <ButtonCustomized
                    onClick={refuseDomiciliationHandler}
                    title="Refuser"
                  />
                  <ButtonCustomized
                    loading={acceptationIsLoading}
                    variant="contained"
                    onClick={accepterDomiciliation}
                    title="Accepter"
                  />
                </Box>
              </PaperCustomized>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexGrow: 1,
                  mt: "20%",
                }}
              >
                <CircularProgress />
              </Box>
            )}
          </>
        )}
      </Box>
      <div ref={contentBottomRef}></div>
      <ScrollToTop />
      <Box>
        <Snackbar
          open={alertOpen}
          autoHideDuration={2000}
          onClose={handleSnackClose}
        >
          <Alert
            onClose={handleSnackClose}
            severity={severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {alertMessage}
          </Alert>
        </Snackbar>
      </Box>
    </Box>
  );
}

export default ReponseDomiciliationBanque;
